import {
  U21FormField,
  U21SelectOptionProps,
  useU21FormState,
} from 'app/shared/u21-ui/components';
import { generateFormFieldProps } from 'app/shared/utils/form';
import { AGENT_FIELD } from 'app/modules/navigator/schema';
import { IconUser } from '@u21/tabler-icons';
import { ImpersonationFormValues } from 'app/modules/navigator/models';
import { useGetOrgAgents } from 'app/modules/orgManagement/queries/useGetOrgAgents';
import { useMemo } from 'react';
import { getAgentDisplayName } from 'app/modules/agents/utils';
import { useSelector } from 'react-redux';
import { selectAgent } from 'app/modules/session/selectors';

export const AgentField = () => {
  const {
    values: { org_id: orgId },
  } = useU21FormState<ImpersonationFormValues>();

  const { id } = useSelector(selectAgent);
  const { data = [], isLoading } = useGetOrgAgents(orgId);

  const options = useMemo(
    () =>
      data
        .filter((a) => a.status === 'ACTIVE' && a.id !== id && a.has_valid_auth)
        .map<U21SelectOptionProps<number>>((a) => {
          const agentName = getAgentDisplayName(a);
          return {
            text: agentName,
            value: a.id,
          };
        }),
    [data, id],
  );

  if (!orgId) {
    return null;
  }

  return (
    <U21FormField
      {...generateFormFieldProps(AGENT_FIELD)}
      fieldProps={{
        startIcon: <IconUser />,
        options,
        placeholder: 'Select agent',
        loading: isLoading,
      }}
    />
  );
};
